<template>
  <div class="cy-wall-paints">
    <div
      v-html="
        $t('wall_paints.description', [
          $store.state.options.prices.room.use_custom_wall_paint + ' €',
          $store.state.options.prices.room.mixed_colors_approximate_price,
        ])
      "
    ></div>

    <item-block
      class="cy-room-paint-block"
      :id="'paints-room-' + room.id"
      v-for="(room, i) in $store.state.rooms"
      :key="'paints-room-' + room.id"
    >
      <base-subheader>
        <span v-html="roomTitle(room)" />
      </base-subheader>

      <RoomPaintOptions :room="room" @input="onRoomInput(i, $event)" :for-title="forTitle(room)" />
    </item-block>
    <div class="my-10">
      <v-alert class="mb-4" type="info" color="blue-grey darken-2" dense>
        <div v-html="$t('wall_paints.alert')"></div>
      </v-alert>
    </div>
  </div>
</template>

<script>
import RoomPaintOptions from "../../room/RoomPaintOptions";
import WallPaintRadio from "../../WallPaintRadio";

export default {
  components: {
    WallPaintRadio,
    RoomPaintOptions,
  },

  methods: {
    onRoomInput(roomIndex, updatables) {
      this.$store.dispatch("setRoom", {
        roomIndex,
        updatables,
      });
    },

    forTitle(room) {
      return this.$t("for " + room.title.toLowerCase());
    },

    roomTitle(room) {
      const length = this.$store.state.rooms.length;

      if (length <= 1) {
        return this.$t("Choose paint");
      }

      const forTitle = this.forTitle(room);

    //   if (length === 2) {
    //     return this.$t("Choose paint {0}", [forTitle]);
    //   }

      const identificator = room.size ? room.size + "m²" : room.index ? room.index : "";

      return this.$t("Choose paint {0}", [`${forTitle} ${identificator}`]);
    },
  },
};
</script>
